import React, { useEffect, useState } from 'react'
import "./Calendar.css"
import axios from 'axios';
import { api } from '../../settings/env';

export default function Calendar({ professional_id, times, services }) {

    const months = {
        1: "Enero",
        2: "Febrero",
        3: "Marzo",
        4: "Abril",
        5: "Mayo",
        6: "Junio",
        7: "Julio",
        8: "Agosto",
        9: "Septiembre",
        10: "Octubre",
        11: "Noviembre",
        12: "Diciembre"
    }

    const mappingDay = {
        0: "Domingo",
        1: "Lunes",
        2: "Martes",
        3: "Miércoles",
        4: "Jueves",
        5: "Viernes",
        6: "Sábado"
    }

    const banks = [
        { code: "0102", name: "Banco de Venezuela" },
        { code: "0104", name: "Banco Mercantil" },
        { code: "0105", name: "Banco Provincial" },
        { code: "0108", name: "Banco Exterior" },
        { code: "0114", name: "Bancaribe" },
        { code: "0115", name: "Banco Occidental de Descuento" },
        { code: "0116", name: "Banco Fondo Común" },
        { code: "0128", name: "Banco Caroní" },
        { code: "0134", name: "Bancrecer" },
        { code: "0138", name: "Banco Plaza" },
        { code: "0151", name: "Banco Nacional de Crédito" },
        { code: "0166", name: "Banco Bicentenario" },
        { code: "0171", name: "Banco Activo" },
        { code: "0175", name: "Banco del Tesoro" },
        { code: "0191", name: "Banco Industrial" },
    ];

    function convertirHoraMilitarACivil(horaMilitar) {
        // Dividir la hora en horas y minutos
        const [horas, minutos] = horaMilitar.split(':').map(Number);

        // Determinar AM o PM
        const ampm = horas >= 12 ? 'PM' : 'AM';

        // Convertir horas a formato de 12 horas
        let horasCivil = horas % 12;
        horasCivil = horasCivil === 0 ? 12 : horasCivil; // 12 AM y 12 PM

        // Formatear la hora civil
        const horaCivil = `${horasCivil}:${String(minutos).padStart(2, '0')} ${ampm}`;

        return horaCivil;
    }

    // Step one
    const [firstDate, setFirstDate] = useState("true");
    const [otherPerson, setOtherPerson] = useState("false");
    const [name, setName] = useState("");
    const [service, setService] = useState("");

    // Step two
    const [daySelected, setDaySelected] = useState(false);
    const [yearSelected, setYearSelected] = useState(2025);
    const [monthsSelected, setMonthsSelected] = useState(1);

    // Step three
    const [time, setTime] = useState("");

    // Step four
    const [paymentMethod, setPaymentMethod] = useState("");

    // Step five

    const [step, setStep] = useState(1);
    const [quantityDays, setQuantityDays] = useState(1);
    const [mappingDaySelected, setMappingDaySelected] = useState(1);
    const [registered, setRegistered] = useState(false);

    const [pagoMovilStep, setPagoMovilStep] = useState(1);


    const nextMonth = () => {
        if (monthsSelected === 12) {
            setMonthsSelected(1);
            setYearSelected((prev) => prev + 1);
        } else {
            setMonthsSelected(monthsSelected + 1);
        }
    }

    const prevMonth = () => {
        if (monthsSelected === 1) {
            setMonthsSelected(12);
            setYearSelected((prev) => prev - 1);
        } else {
            setMonthsSelected(monthsSelected - 1);
        }
    }

    const handleSelectDay = (day) => {
        console.log(day);
        setDaySelected(day);
        setStep(3);
    }

    const validateStepOne = () => {

    }

    const renderDays = (datetime) => {

        if (datetime) {
            // Obtener el dia
            const dayOfWeek = datetime.getDay()
            setMappingDaySelected(parseInt(dayOfWeek));

            // Obtener el mes
            const month = datetime.getMonth();
            setMonthsSelected(parseInt(month) + 1);

            console.log("Entro en modo manual")
            console.log(datetime, dayOfWeek)
        } else {
            console.log("Modo default")
            // Año-Mes-Dia
            const dateString = `${yearSelected}-${monthsSelected}-01`;
            const date = new Date(dateString);
            const dayOfWeek = date.getDay()
            setMappingDaySelected(parseInt(dayOfWeek));
            console.log(dateString, date, dayOfWeek);
            setQuantityDays(getDaysInMonth(yearSelected, monthsSelected - 1))
        }
    }

    function getDaysInMonth(year, month) {
        // El mes se especifica en base 0 (0 = enero, 11 = diciembre)
        return new Date(year, month + 1, 0).getDate();
    }

    useEffect(() => {
        // Obtener fecha actual
        const currentDate = new Date();
        renderDays(currentDate);

        // Obtener dias del mes actual
        setQuantityDays(getDaysInMonth(currentDate.getFullYear(), currentDate.getMonth()))
    }, [])

    useEffect(() => {
        renderDays()
    }, [monthsSelected])


    // 
    const elements = Array.from({ length: quantityDays - 1 }, (_, index) => (
        <li key={index} onClick={() => handleSelectDay(index + 2)}>
            {index + 2}
        </li>
    ));

    const handleStep = (new_step) => {
        if (step > new_step) {
            setStep(new_step);
        }
    }

    const handleTime = (time) => {
        setTime(time);
        setStep(4);
    }

    const handlePaymentMethod = (method) => {
        setPaymentMethod(method);
        setStep(6);
    }

    const otherPersonHandle = (e) => {
        console.log('otherPerson', e.target.value);

        if (e.target.value == "true") {
            console.log('Otro nombre activado');
        } else {
            const user_data = localStorage.getItem('vitaly_user');
            console.log("Full Date");
            console.log(JSON.parse(user_data));
            setName(JSON.parse(user_data));
        }

        setOtherPerson(e.target.value);
    };

    const handleFirstDate = (e) => {
        setFirstDate(e.target.value);
    }

    const paymentProcess = () => {
        setRegistered(true)

        const data = {
            professional_id: professional_id,
            user_id: localStorage.getItem('vitaly_userid'),
            month_code: monthsSelected,
            month_name: months[monthsSelected],
            time: time,
            day: daySelected,
            year: yearSelected,
            color: "red",
            status: "Por confirmar",
            service: service,
            first_date: firstDate,
            full_name: name,
            ci_user: "",
            pay_method: paymentMethod,
            pay_reference: "",
            pay_bank: "",
            pay_amount: 0.0,
            pay_phone: ""

        }

        console.log("Yayayajuu", data);

        axios.post(`${api}/appoinments/create`, data)
            .then(resp => {
                console.log("Response", resp);
                // setStep(5);
            })
            .catch(err => {
                console.log("Error", err);
            });
    };

    useEffect(() => {
        const user_data = localStorage.getItem('vitaly_user');
        console.log("Full Date");
        
        if(JSON.parse(user_data).fullName){
            console.log(JSON.parse(user_data));
            setName(JSON.parse(user_data).fullName);
        }else{
            setName("Usuario");
        }

        
    }, [])

    return (
        <div className='container-calendar'>
            <h1>Agendar una cita</h1>
            <p>Y prepara tu hora de consulta</p>

            <div className="steps-calendar">
                <div className='calendar-item active' onClick={() => handleStep(1)}>
                    <img src="/assets/icons/data-white.png" width={"66%"} alt="" />
                    {step == 1 && "Datos"}
                    {step == 1 && <div className="arrow-right"></div>}
                </div>

                <div className={step == 2 || step > 2 ? 'calendar-item active' : 'calendar-item'} onClick={() => handleStep(2)}>
                    <img src={step == 2 || step > 2 ? "/assets/icons/calendar-white.png" : "/assets/icons/calendar.png"} width={"66%"} alt="" />
                    {step == 2 && <span style={{ marginLeft: "5px" }}>Fecha</span>}
                    {step == 2 && <div className="arrow-right"></div>}
                </div>

                <div className={step == 3 || step > 3 ? 'calendar-item active' : 'calendar-item'} onClick={() => handleStep(3)}>
                    <img src={step == 3 || step > 3 ? "/assets/icons/time-white.png" : "/assets/icons/time.png"} width={"66%"} alt="" />
                    {step == 3 && <span style={{ marginLeft: "5px" }}>Hora</span>}
                    {step == 3 && <div className="arrow-right"></div>}
                </div>

                <div className={step == 4 || step > 4 ? 'calendar-item active' : 'calendar-item'} onClick={() => handleStep(4)}>
                    <img src={step == 4 || step > 4 ? "/assets/icons/offer-white.png" : "/assets/icons/offer-color.png"} width={"66%"} alt="" />
                    {step == 4 && <span style={{ marginLeft: "5px" }}>Código</span>}
                    {step == 4 && <div className="arrow-right"></div>}
                </div>

                <div className={step == 5 || step > 5 ? 'calendar-item active' : 'calendar-item'} onClick={() => handleStep(5)}>
                    <img src={step == 5 || step > 5 ? "/assets/icons/pay-methods-white.png" : "/assets/icons/pay-methods.png"} width={"66%"} alt="" />
                    {step == 5 && <span style={{ marginLeft: "5px" }}>Méto.</span>}
                    {step == 5 && <div className="arrow-right"></div>}
                </div>

                <div className={step == 6 ? 'calendar-item active' : 'calendar-item'}>
                    <img src={step == 6 || step > 6 ? "/assets/icons/pay-white.png" : "/assets/icons/pay.png"} width={"66%"} alt="" />
                    {step == 6 && <span style={{ marginLeft: "5px" }}>Pagar</span>}
                </div>
            </div>

            {
                step == 1 &&
                <div className="time-selection">

                    <p>
                        <b>Dirección:</b>
                    </p>
                    Caracas

                    <br />

                    <span style={{ marginRight: "10px" }}>
                        <b>Servicio:</b>
                    </span>
                    <select
                        onChange={(e) => setService(e.target.value)}
                        style={{
                            display: "inline",
                            width: "190px",
                            marginTop: "10px",
                            marginBottom: "10px",
                        }}
                        class="form-select" name="" id="">
                        <option>Todos los servicios</option>

                        {
                            services.map(service => (
                                <option value={service.id}>{service.name}</option>
                            ))
                        }

                    </select>

                    <p style={{ marginTop: "20px" }}>
                        <b>¿Es tu primera visita con este especialista?</b>
                    </p>
                    <input
                        style={{ marginRight: "10px" }}
                        type="radio" id="si"
                        name="primera-visita"
                        value="true"
                        checked={firstDate === "true"}
                        onChange={handleFirstDate}
                    />
                    <label
                        style={{ marginRight: "10px" }}
                        className="form-check-label">
                        Sí
                    </label>
                    <input
                        style={{ marginRight: "10px" }}
                        type="radio"
                        name="primera-visita"
                        value="false"
                        checked={firstDate === "false"}
                        onChange={handleFirstDate}
                    />
                    <label className="form-check-label">
                        No
                    </label>

                    <p style={{ marginTop: "20px" }}>
                        <b>¿Desea Agendar a nombre de otra persona?</b>
                    </p>

                    {
                        otherPerson === "true" ?

                            <div className="form-personal">
                                <input
                                    type="text"
                                    onKeyUp={(e) => setName(e.target.value)}
                                    placeholder="Nombre"
                                    style={{ marginBottom: "10px" }}
                                />
                            </div>
                            :
                            <>
                                <input
                                    style={{ marginRight: "10px" }}
                                    type="radio"
                                    name="other_name"
                                    value="true"
                                    checked={otherPerson === "true"}
                                    onChange={otherPersonHandle}
                                />
                                <label
                                    style={{ marginRight: "10px" }}
                                    className="form-check-label" htmlFor="flexRadioDefault1"

                                >

                                    Sí
                                </label>
                                <input
                                    style={{ marginRight: "10px" }}

                                    type="radio"
                                    name="other_name"
                                    value="false"
                                    checked={otherPerson === "false"}
                                    onChange={otherPersonHandle}
                                />
                                <label className="form-check-label" htmlFor="flexRadioDefault1">
                                    No
                                </label>
                            </>
                    }

                    <br />

                    <button className='btn btn-primary' style={{ marginTop: "20px" }} onClick={() => setStep(2)}>
                        Siguiente
                    </button>
                </div>
            }

            {
                step == 2 &&
                <>
                    <div className="control-mount">
                        <div className="prev" onClick={prevMonth}>
                            <img src="/assets/icons/chevron-left.svg" width={"70%"} alt="" />
                        </div>
                        <h4>{months[monthsSelected]} {yearSelected}</h4>
                        <div className="next" onClick={nextMonth}>
                            <img src="/assets/icons/chevron-right.svg" width={"70%"} alt="" />
                        </div>
                    </div>

                    <ol>
                        <li className='day-name'>Dom</li>
                        <li className='day-name'>Lun</li>
                        <li className='day-name'>Mar</li>
                        <li className='day-name'>Mié</li>
                        <li className='day-name'>Jue</li>
                        <li className='day-name'>Vie</li>
                        <li className='day-name'>Sáb</li>

                        <li className='first-day'
                            style={{ gridColumnStart: `${mappingDaySelected + 1}` }}
                            onClick={() => handleSelectDay(1)}
                        >
                            1
                        </li>


                        {elements}

                    </ol>
                </>


            }

            {
                step == 3 && <div>
                    <ul className='timer'>

                        {
                            times.map(time => (
                                <li onClick={() => handleTime(time)}>
                                    {convertirHoraMilitarACivil(time)}
                                </li>
                            ))
                        }

                    </ul>

                </div>
            }

            {
                step == 4 && registered == false && <div className='code'>

                    <p>
                        <b>Datos de la cita</b>
                    </p>
                    <p><b>Fecha:</b> {`${daySelected} de ${months[monthsSelected]} ${yearSelected}`}</p>
                    <p><b>Hora:</b> {time}</p>
                    <p><b>Precio:</b> {time}</p>

                    <br /><br />

                    <p>Codigo de promoción</p>
                    <input type="text" placeholder="Ingrese el código" />
                    <button className='btn-code'>Validar</button>

                    <br /><br />

                    <button className='btn btn-primary' onClick={() => setStep(5)}>
                        Continuar
                    </button>
                </div>
            }



            {
                step == 5 && <div>
                    <p>Selecciona un método de pago</p>
                    <div className="grid-methods">
                        <div className="method-item" onClick={() => handlePaymentMethod("pago-movil")}>
                            <img src="/assets/icons/credit-card.png" alt="" />
                            <p>Págo Móvil</p>
                        </div>

                        {/* <div className="method-item" onClick={() => setPaymentMethod("Tarjeta de débito")}>
                            <img src="/assets/icons/debit-card.png" alt="" />
                            <p>Tarjeta de débito</p>
                        </div>
                        
                        <div className="method-item" onClick={() => setPaymentMethod("Transferencia bancaria")}>
                            <img src="/assets/icons/transfer.png" alt="" />
                            <p>Transferencia bancaria</p>
                        </div> */}
                    </div>
                </div>
            }

            {
                step == 6 && registered == false && <div>
                    {
                        pagoMovilStep == 1 ?
                            <>
                                <p>
                                    <b>Pago Movil</b>
                                </p>
                                <p>
                                    <b>Documento:</b> J50487755
                                </p>
                                <p>
                                    <b>Banco:</b> Venezuela
                                </p>
                                <p>
                                    <b>Nro. de teléfono:</b> 042456878594
                                </p>

                                <button className='btn btn-primary' onClick={() => setPagoMovilStep(2)}>
                                    Pagar
                                </button>
                            </>
                            :
                            <>
                                <p>Ingrese la información del pago realizado</p>

                                <div className="form-personal">
                                    <input
                                        type="text"
                                        placeholder="Nro. de referencia"
                                        onKeyUp={(e) => console.log(e.target.value)}
                                    />

                                    <select style={{ height: "66px" }} id="bankSelect" className="form-control">
                                        <option value="">-- Selecciona un banco --</option>
                                        {banks.map((bank) => (
                                            <option key={bank.code} value={bank.code}>
                                                {bank.code} - {bank.name}
                                            </option>
                                        ))}
                                    </select>

                                    <input
                                        type="text"
                                        placeholder="Nro. de teléfono"
                                        onKeyUp={(e) => console.log(e.target.value)}
                                    />
                                </div>

                                <br />

                                <button className='btn btn-primary' onClick={paymentProcess}>
                                    Enviar Pago
                                </button>
                            </>
                    }



                </div>
            }

            {
                step == 6 && registered == true && <div>
                    <p>¡Registrado exitosamente!</p>
                    <img src="https://media.tenor.com/Hw7f-4l0zgEAAAAM/check-green.gif" alt="" />
                </div>
            }


        </div>
    )
}
